// @ts-check
import { attrConfig as wId } from './w-id.js';
import { attrConfig as wName } from './w-name.js';
import { attrConfig as wColFirst } from './w-col-first.js';
import { attrConfig as wColLast } from './w-col-last.js';
import { attrConfig as wDisplacedByCustomXml } from './w-displaced-by-custom-xml.js';

/**
 * All valid attributes for the <w:bookmarkStart> element
 * @type {import('@translator').AttrConfig[]}
 */
export default [wId, wName, wColFirst, wColLast, wDisplacedByCustomXml];
